import { Injectable } from '@angular/core';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { Action } from '@ngrx/store/src/models';
import { ChangePasswordService } from '../../services/change-password/change-password.service';
import {
  ChangePasswordActionTypes,
  ChangePasswordSuccessAction,
  ChangePasswordErrorAction
} from '../../actions/change-password/change-password.actions';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';

@Injectable()
export class ChangePasswordEffects {
  @Effect()
  public changePassword(): Observable<Action> {
    return this.actions.pipe(
      ofType(ChangePasswordActionTypes.REQUEST),
      exhaustMap((action: any) => {
        return this.changePasswordService.changePassword(action.oldPassword, action.newPassword).pipe(
          map(response => {
            if (!response.success) {
              return ChangePasswordErrorAction({ error: new Error(response.errorMessage) });
            }
            return ChangePasswordSuccessAction({ response: <ApiResponseSimple>response });
          }),
          catchError(error => of(ChangePasswordErrorAction({ error })))
        );
      })
    );
  }

  constructor(private actions: Actions, private changePasswordService: ChangePasswordService) {}
}
